import script from "./mobileContactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileContactUs.vue?vue&type=script&setup=true&lang=js"

import "./mobileContactUs.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__